import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { OnlinePaymentsService } from './online-payments.service';

angular.module('app-lite.online-payments', [])
.service('onlinePaymentsApi', downgradeInjectable(OnlinePaymentsService));
